<template>
	<div class="profile">
		<!-- 介绍内容 -->
		<div class="title">{{detail.title}}</div>
		<div class="content" ref="richText" v-html='detail.content'></div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				detail: []
			}
		},
		created() {
			let that = this,
				ids = that.$route.query.id;
			//新闻列表
			that.$axios.post(baseUrl + '/mobile/Base/aboutInfo', {
				id: ids
			}).then(function(res) {
				if (res.data.code == 2) {
					that.detail = res.data.data
				}
			}).catch(function(err) {
				console.log(err);
			});
		}
	}
</script>

<style scoped>
	@import "profile.css";
	
	.title {
		margin-top: 1rem;
		width: 100%;
	}

	.layer {
		width: 100%;
		height: 3rem;
	}
</style>



// WEBPACK FOOTER //
// src/components/min/about/treaty.vue